export default "__VITE_ASSET__Cn712Fnn__"